"use client";

import { defaultLocale } from "@/lib/getSite";
import { I18nClientContext } from "@/messages/client";

import { useContext } from "react";

export const useCurrentLocale = () => {
  const context = useContext(I18nClientContext);

  return context?.locale ?? defaultLocale;
};
